import { getApiBaseUrl } from '@/utils/apiConfig'

function getCookie(name) {
    const cookies = document.cookie.split(';');
    
    for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    
    return '';
}

function getDefaultServer() {
    const apiBaseUrl = getApiBaseUrl()
    if (apiBaseUrl) {
        return apiBaseUrl.replace(/\/$/, '')
    }
    return window.siteUrl || window.location.origin
}

export const auth = {
    get server() {
        return getDefaultServer()
    },
    get username() {
        return getCookie('username') || ''
    },
    get salt() {
        return getCookie('salt') || ''
    },
    get hash() {
        return getCookie('hash') || ''
    },
    isValid() {
        return this.username && this.salt && this.hash;
    }
}
